<template>
  <div class="signup-league-detail column is-half-tablet is-one-third-desktop is-one-quarter-widescreen">
    <div class="signup-league-price card is-primary is-outlined">
      <div class="card-content">
        <p class="title">{{ league.name }}</p>
        <p class="subtitle">{{ league.day | formatDay }}s</p>
        <p style="margin-bottom: 1.25rem;">{{ formattedTimes }}</p>
        <div class="price">
          <p>Price:</p>
          <span v-if="!isEarlyBird">${{ league.entryPrice }}</span>
          <span v-else><s>${{ league.entryPrice }}</s> ${{ league.earlyBirdPrice }} </span>
          <div>
            <b-tag v-if="isEarlyBird" type="is-info">Early Bird Special!</b-tag>
          </div>
        </div>
        <div v-if="league.teams.length > 0">
          <p style="margin-bottom: 1.25rem;">{{ league.teams.length}} team{{ league.teams.length > 1 ? 's have' : ' has'}} signed up already.</p>
          <ul>
            <li v-for="team in league.teams" :key="team.id" class="signup-team-detail">
              <p>{{ team.name | capitalize }}</p>
              <p>Captain {{ team.captain.name | capitalize }}</p>
            </li>
          </ul>
        </div>
        <router-link :to="`/leagues/signup/${season.id}/league/${league.id}`" class="button is-primary is-rounded">Signup</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'SignupLeagueDetail',
  props: {
    league: {
      type: Object,
      required: true
    },
    season: {
      type: Object,
      required: true
    }
  },
  computed: {
    formattedTimes() {
        return this.league.times.map(time => `${time}${'pm'}`).join(", ");
    },
    isEarlyBird() {
        let earlyBird = moment(this.season.earlyBirdEnd, "YYYY-MM-DD");
        let now = moment();
        return moment.duration(now - earlyBird).days() <= 0;
    }
  },
  filters: {
    formatDay(day) {
      const mapping = {
        "Sun": "Sunday",
        "Mon": "Monday",
        "Tue": "Tuesday",
        "Wed": "Wednesday",
        "Thu": "Thursday",
        "Fri": "Friday",
        "Sat": "Saturday",
      }
      return mapping[day];
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  p.title {
    font-size: 1.5rem;
  }
  .price {
    margin-bottom: 1.5rem;
  }
  .signup-team-detail {
    margin-bottom: 0.75rem;
    text-align: center;
  }
</style>